import { HELP_CENTER_FULL_PATH } from "@src/appV2/HelpCenter/paths";
import { NavigationMenuSectionTitle } from "@src/appV2/redesign/AppLayout/Navigation/MenuSectionTitle";
import { getLocation } from "@src/utils/routes";

import { NavigationMenuItem } from "../../appV2/redesign/AppLayout/Navigation/MenuItem";
import { useWorkplaceMenuPriviligesProviderContext } from "./priviligesProviders/WorkplaceMenuPriviligesProvider";

/* eslint-disable complexity */
export function WorkplaceNavigationMenuItemsContainer() {
  const workplaceMenuPriviliges = useWorkplaceMenuPriviligesProviderContext();

  const currentLocation = location.pathname;

  // Core routes
  const facilityOnboardingLoc = getLocation("facilityOnboarding");
  const agentDashboardLoc = getLocation("agentDashboard");
  const facilityChatLoc = getLocation("facilityChat");

  // Professionals
  const workplaceWorkersLoc = getLocation("workplaceWorkers");
  const workersDirectoryLoc = getLocation("workersDirectory");

  // Permanent Hiring
  const jobsLandingPageLoc = getLocation("jobsLandingPage");
  const manageJobsLoc = getLocation("manageJobs");
  const workplaceHireProfessionalsLoc = getLocation("workplaceHireProfessionals");
  const interviewSettingsLoc = getLocation("interviewSettings");

  // Charting & Analytics
  const workplaceChartingLoc = getLocation("workplaceCharting");
  const workplaceAnalyticsLoc = getLocation("workplaceAnalytics");

  // Live Worker ETA
  const facilityLiveWorkerETALoc = getLocation("facilityLiveWorkerETA");

  // Management
  const myAccountLoc = getLocation("myAccount");
  const workplaceUsersLoc = getLocation("workplaceUsers");
  const facilitySettingsLoc = getLocation("facilitySettings");
  const facilityTimeclockSettingsLoc = getLocation("facilityTimeclockSettings");

  // Billing
  const facilityInvoiceUpcomingChargesLoc = getLocation("facilityInvoiceUpcomingCharges");
  const facilityInvoiceHistoryLoc = getLocation("facilityInvoiceHistory");
  const facilityInvoiceContractTermsLoc = getLocation("facilityInvoiceContractTerms");

  // Refer & Earn
  const workplaceReferAndEarnLoc = getLocation("workplaceReferAndEarn");

  return (
    <>
      {workplaceMenuPriviliges.workplaceOnboarding && (
        <NavigationMenuItem
          iconType="hybrid-view"
          isSelected={facilityOnboardingLoc.pathname === currentLocation}
          routeTo={facilityOnboardingLoc}
        >
          Getting started
        </NavigationMenuItem>
      )}

      {workplaceMenuPriviliges.calendar && (
        <NavigationMenuItem
          iconType="calendar"
          isSelected={agentDashboardLoc.pathname === currentLocation}
          routeTo={agentDashboardLoc}
        >
          Calendar
        </NavigationMenuItem>
      )}

      {workplaceMenuPriviliges.chat && (
        <NavigationMenuItem
          iconType="message"
          isSelected={facilityChatLoc.pathname === currentLocation}
          routeTo={facilityChatLoc}
        >
          Chat
        </NavigationMenuItem>
      )}

      {workplaceMenuPriviliges.professionalsSection && (
        <>
          <NavigationMenuSectionTitle>Professionals</NavigationMenuSectionTitle>
          {workplaceMenuPriviliges.professionalsSection.myProfessionals && (
            <NavigationMenuItem
              iconType="folder-person"
              isSelected={workplaceWorkersLoc.pathname === currentLocation}
              routeTo={workplaceWorkersLoc}
            >
              My Professionals
            </NavigationMenuItem>
          )}
          {workplaceMenuPriviliges.professionalsSection.myProfessionals && (
            <NavigationMenuItem
              iconType="people"
              isSelected={workersDirectoryLoc.pathname === currentLocation}
              routeTo={workersDirectoryLoc}
            >
              Browse Professionals
            </NavigationMenuItem>
          )}
        </>
      )}

      {workplaceMenuPriviliges.permanentHiringSection && (
        <>
          <NavigationMenuSectionTitle>Permanent Hiring</NavigationMenuSectionTitle>
          {workplaceMenuPriviliges.permanentHiringSection.placementsLandingPage && (
            <NavigationMenuItem
              iconType="ribbon"
              isSelected={jobsLandingPageLoc.pathname === currentLocation}
              routeTo={jobsLandingPageLoc}
            >
              Landing Page
            </NavigationMenuItem>
          )}
          {workplaceMenuPriviliges.permanentHiringSection.applicationAndJobs && (
            <NavigationMenuItem
              iconType="briefcase"
              isSelected={manageJobsLoc.pathname === currentLocation}
              routeTo={manageJobsLoc}
            >
              Application & Jobs
            </NavigationMenuItem>
          )}
          {workplaceMenuPriviliges.permanentHiringSection.browseTalentPool && (
            <NavigationMenuItem
              iconType="person-superstar"
              isSelected={workplaceHireProfessionalsLoc.pathname === currentLocation}
              routeTo={workplaceHireProfessionalsLoc}
            >
              Browse Talent Pool
            </NavigationMenuItem>
          )}
          {workplaceMenuPriviliges.permanentHiringSection.interviewAvailability && (
            <NavigationMenuItem
              iconType="person-male-formal"
              isSelected={interviewSettingsLoc.pathname === currentLocation}
              routeTo={interviewSettingsLoc}
            >
              Interview Availability
            </NavigationMenuItem>
          )}
        </>
      )}

      {workplaceMenuPriviliges.charting && (
        <>
          <NavigationMenuSectionTitle>Charting</NavigationMenuSectionTitle>
          <NavigationMenuItem
            iconType="chart-line-increase"
            isSelected={workplaceChartingLoc.pathname === currentLocation}
            routeTo={workplaceChartingLoc}
          >
            Charting
          </NavigationMenuItem>
        </>
      )}

      {workplaceMenuPriviliges.analytics && (
        <>
          <NavigationMenuSectionTitle>Analytics</NavigationMenuSectionTitle>
          <NavigationMenuItem
            iconType="microscope"
            isSelected={workplaceAnalyticsLoc.pathname === currentLocation}
            routeTo={workplaceAnalyticsLoc}
          >
            Analytics
          </NavigationMenuItem>
        </>
      )}

      {workplaceMenuPriviliges.liveWorkerETA && (
        <>
          <NavigationMenuSectionTitle>Live Worker ETA</NavigationMenuSectionTitle>
          <NavigationMenuItem
            iconType="coordinates-person"
            isSelected={facilityLiveWorkerETALoc.pathname === currentLocation}
            routeTo={facilityLiveWorkerETALoc}
          >
            Live Worker ETA
          </NavigationMenuItem>
        </>
      )}

      {workplaceMenuPriviliges.managementSection && (
        <>
          <NavigationMenuSectionTitle>Management</NavigationMenuSectionTitle>
          {workplaceMenuPriviliges.managementSection.myAccount && (
            <NavigationMenuItem
              iconType="person-male"
              isSelected={myAccountLoc.pathname === currentLocation}
              routeTo={myAccountLoc}
            >
              My Account
            </NavigationMenuItem>
          )}
          {workplaceMenuPriviliges.managementSection.teamMembers && (
            <NavigationMenuItem
              iconType="group"
              isSelected={workplaceUsersLoc.pathname === currentLocation}
              routeTo={workplaceUsersLoc}
            >
              Team Members
            </NavigationMenuItem>
          )}
          {workplaceMenuPriviliges.managementSection.settings && (
            <NavigationMenuItem
              iconType="cogwheel"
              isSelected={facilitySettingsLoc.pathname === currentLocation}
              routeTo={facilitySettingsLoc}
            >
              Settings
            </NavigationMenuItem>
          )}
          {workplaceMenuPriviliges.managementSection.timeclockingSettings && (
            <NavigationMenuItem
              iconType="cogwheel"
              isSelected={facilityTimeclockSettingsLoc.pathname === currentLocation}
              routeTo={facilityTimeclockSettingsLoc}
            >
              Timeclocking Settings
            </NavigationMenuItem>
          )}
        </>
      )}

      {workplaceMenuPriviliges.billingSection && (
        <>
          <NavigationMenuSectionTitle>Billing</NavigationMenuSectionTitle>
          {workplaceMenuPriviliges.billingSection.upcomingCharges && (
            <NavigationMenuItem
              iconType="dollar"
              isSelected={facilityInvoiceUpcomingChargesLoc.pathname === currentLocation}
              routeTo={facilityInvoiceUpcomingChargesLoc}
            >
              Upcoming Charges
            </NavigationMenuItem>
          )}
          {workplaceMenuPriviliges.billingSection.invoiceHistory && (
            <NavigationMenuItem
              iconType="money-dollar"
              isSelected={facilityInvoiceHistoryLoc.pathname === currentLocation}
              routeTo={facilityInvoiceHistoryLoc}
            >
              Invoice History
            </NavigationMenuItem>
          )}
          {workplaceMenuPriviliges.billingSection.contractTerms && (
            <NavigationMenuItem
              iconType="notepad-alt"
              isSelected={facilityInvoiceContractTermsLoc.pathname === currentLocation}
              routeTo={facilityInvoiceContractTermsLoc}
            >
              Contract Terms
            </NavigationMenuItem>
          )}
        </>
      )}

      {workplaceMenuPriviliges.helpCenter && (
        <>
          <NavigationMenuSectionTitle>Help Center</NavigationMenuSectionTitle>
          <NavigationMenuItem
            iconType="question-circle"
            isSelected={false}
            onClick={() => {
              window.open(HELP_CENTER_FULL_PATH);
            }}
          >
            Help Center
          </NavigationMenuItem>
        </>
      )}

      {workplaceMenuPriviliges.referAndEarn && (
        <>
          <NavigationMenuSectionTitle>Help Center</NavigationMenuSectionTitle>
          <NavigationMenuItem
            iconType="palm-dollar"
            isSelected={workplaceReferAndEarnLoc.pathname === currentLocation}
            routeTo={workplaceReferAndEarnLoc}
          >
            Refer & Earn
          </NavigationMenuItem>
        </>
      )}
    </>
  );
}
/* eslint-enable complexity */
